import { action } from 'satcheljs';

/**
 * Action to initialize the week start view state when week start option is loaded, this takes care of resetting the state and avoiding race conditions
 */
const initializeWeekStartOptionViewState = action('initializeWeekStartOptionViewState');

export default initializeWeekStartOptionViewState;
